module.exports = __webpack_public_path__ + "static/media/Lotto90.7b3aaba7.jpg";